export const SET_CONFIG_TYPE = 'CONFIG_DATA';

export const setConfigApp = (config) => {
    return {
        type: SET_CONFIG_TYPE,
        payload: config
    }
}
